import React from "react";

const AboutFour = () => {
  return (
    <div className="section section-padding case-study-featured-area">
      <div className="container">
        <div className="row pt-5">
          <div className="col-xl-12 pt-5 text-center">
            <h2 className="title h2">About CLIF AI – Your AI Career Partner</h2>
          </div>
          <div className="col-xl-7 col-lg-6">
            <div className="case-study-featured-thumb text-start">
              <img
                src={process.env.PUBLIC_URL + "/images/recruiters/new.jpg"}
                alt="our story"
              />
            </div>
          </div>
          <div className="col-xl-5 col-lg-6">
            <div className="case-study-featured">
              <div className="section-heading heading-left">
                <h4 className="title h2"></h4>
                <p>
                  In the depths of a harsh U.S. winter, two former Amazon
                  engineers, driven by firsthand insights into the challenges
                  bridging academia and industry, envisioned a transformative
                  solution. Leveraging their expertise, they conceptualized CLIF
                  AI—a platform that seamlessly integrates artificial
                  intelligence with human mentorship to address the disconnect
                  between educational institutions and the professional world.
                  Their vision materialized rapidly, culminating in a platform
                  poised to empower individuals, universities, and recruiters
                  alike. By offering features such as resume building,
                  personalized career roadmaps, video interview analysis, core
                  and professional skills training, and skill tracking, CLIF AI
                  stands ready to revolutionize career development and
                  profoundly impact millions globally.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
<style>
  {`
    @media only screen and (max-width: 991px) {
          .section-heading .title {
            font-size: 45px;
          }
        }
  `}
</style>;

export default AboutFour;
